/**
 * gem-caption.js  v16
 *
 * v15からの変更点:
 *   - mw-option__price の data-price-formatted スキップ判定を削除。
 *     APO再描画後に +¥XX が復活しても毎回処理されるよう修正。
 *     +¥1,800 / (+¥1,800) / ¥1,800 いずれの形式も統一して ¥X,XXX に整形。
 */

(function () {
  'use strict';

  var CAPTION_MAP = [
    { key: 'yellow10', label: 'K10YG　画像はイメージです' },
    { key: 'yellow14', label: 'K14YG　画像はイメージです' },
    { key: 'yellow',   label: 'K18YG / 925SV YGP　画像はイメージです' },
    { key: 'rose',     label: 'K18 RG / K14 RG / K10 RG / 925SV RGP　画像はイメージです' },
    { key: 'platinum', label: 'PT900 / K10 RHP / 925SV RHP　画像はイメージです' },
  ];

  function getBasename(url) {
    if (!url) return '';
    return url.split('?')[0].split('/').pop().replace(/\.[^.]+$/, '').toLowerCase();
  }

  function getCaptionFromUrl(url) {
    if (!url) return null;
    var basename = getBasename(url);
    var numMatch = basename.match(/[_-](\d{3})(?:[_\-.]|$)/);
    var prefix = numMatch ? '#' + numMatch[1] + '　' : '';
    for (var i = 0; i < CAPTION_MAP.length; i++) {
      var k = CAPTION_MAP[i].key;
      var pattern = new RegExp('(?:_|-)' + k + '(?:$|_|-)');
      if (pattern.test(basename)) {
        return prefix + CAPTION_MAP[i].label;
      }
    }
    return null;
  }

  function getItemNumber(url) {
    if (!url) return null;
    var basename = getBasename(url);
    var numMatch = basename.match(/[_-](\d{3})(?:[_\-.]|$)/);
    return numMatch ? '#' + numMatch[1] : null;
  }

  function getCurrentMainSrc() {
    var blocks = document.querySelectorAll('.product-media.product-media--image');
    for (var i = 0; i < blocks.length; i++) {
      if (blocks[i].style.display === 'block') {
        var link = blocks[i].querySelector('a.main-img-link');
        if (link && link.href) {
          getCurrentMainSrc._cache = link.href;
          return link.href;
        }
      }
    }
    if (getCurrentMainSrc._cache) return getCurrentMainSrc._cache;
    var firstLink = document.querySelector('a.main-img-link');
    if (firstLink && firstLink.href) return firstLink.href;
    return '';
  }

  function getCurrentMediaBlock() {
    var blocks = document.querySelectorAll('.product-media.product-media--image');
    for (var i = 0; i < blocks.length; i++) {
      if (blocks[i].style.display === 'block') return blocks[i];
    }
    return blocks[0] || null;
  }

  function getOrCreateCaptionEl() {
    var existing = document.getElementById('gem-image-caption');
    if (existing) return existing;
    var el = document.createElement('p');
    el.id        = 'gem-image-caption';
    el.className = 'gem-image-caption';
    var slickSlider = document.querySelector('.slick-slider');
    if (slickSlider && slickSlider.parentNode) {
      slickSlider.parentNode.insertBefore(el, slickSlider);
      return el;
    }
    var main = document.querySelector('.main') || document.body;
    main.appendChild(el);
    return el;
  }

  function updateCaption() {
    var src     = getCurrentMainSrc();
    var caption = getCaptionFromUrl(src);
    var el      = getOrCreateCaptionEl();
    if (caption) {
      el.textContent = caption;
      el.classList.add('is-visible');
    } else {
      el.textContent = '';
      el.classList.remove('is-visible');
    }
  }

  function getOrCreateBarEl() {
    var existing = document.getElementById('gem-image-bar');
    if (existing) return existing;
    var bar = document.createElement('div');
    bar.id        = 'gem-image-bar';
    bar.className = 'gem-image-bar';
    bar.innerHTML =
      '<span class="gem-image-bar__left">One of a kind</span>' +
      '<span class="gem-image-bar__right"></span>';
    var block = getCurrentMediaBlock();
    if (block) {
      var link = block.querySelector('a.main-img-link');
      if (link) {
        block.insertBefore(bar, link);
      } else {
        block.appendChild(bar);
      }
    }
    return bar;
  }

  function updateBar() {
    var src    = getCurrentMainSrc();
    var number = getItemNumber(src);
    var bar    = getOrCreateBarEl();
    var block  = getCurrentMediaBlock();
    if (block && bar.parentNode !== block) {
      block.appendChild(bar);
    }
    if (number) {
      bar.querySelector('.gem-image-bar__right').textContent = number;
      bar.classList.add('is-visible');
    } else {
      bar.classList.remove('is-visible');
    }
  }

  function updateAll() {
    updateCaption();
    updateBar();
  }

  function bindThumbEvents() {
    document.querySelectorAll('a.thumbnail[data-media-id]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        setTimeout(updateAll, 100);
        setTimeout(updateAll, 300);
        setTimeout(updateAll, 600);
      });
    });
  }

  function bindSwatchEvents() {
    document.querySelectorAll('.gem-swatch-item').forEach(function (item) {
      item.addEventListener('click', function () {
        setTimeout(updateAll, 100);
        setTimeout(updateAll, 300);
      });
    });
  }

  function bindMetalColorEvents() {
    document.addEventListener('change', function (e) {
      if (!e.target.classList.contains('mw-option__control')) return;
      setTimeout(updateAll, 300);
      setTimeout(updateAll, 700);
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('.gem-metal-color-option')) return;
      setTimeout(updateAll, 300);
      setTimeout(updateAll, 700);
    });
  }

  /* -------------------------------------------------------
     機能3: APOスウォッチラベルの整形（HTMLで生成）
  ------------------------------------------------------- */

  function formatSwatchLabels() {
    document.querySelectorAll('span.mw-text.mw-option__value-text').forEach(function (el) {
      if (el.getAttribute('data-caption-formatted')) return;

      var original = el.getAttribute('data-original-text') || el.textContent.trim();
      if (!el.getAttribute('data-original-text')) {
        el.setAttribute('data-original-text', original);
      }

      var hasCt = original.match(/([\d.]+[Cc][Tt])/);
      var hasMm = original.match(/([\d.]+×[\d.]+mm)/);
      if (!hasCt && !hasMm && original.indexOf('1点もの') === -1) return;

      var line1 = '';
      var line2 = '';

      if (original.indexOf('1点もの') !== -1) {
        var numMatch = original.match(/#(\d{3})/);
        line1 = numMatch ? '#' + numMatch[1] : '';
        var ctMatch = original.match(/([\d.]+ct)/i);
        var mmMatch = original.match(/([\d.]+×[\d.]+mm)/);
        line2 = [ctMatch ? ctMatch[1] : '', mmMatch ? mmMatch[1] : ''].filter(Boolean).join('　');
      } else {
        var ctMatch2 = original.match(/([\d.]+[Cc][Tt](?:前後)?)/);
        var mmMatch2 = original.match(/(約?[\d.]+×[\d.]+mm)/);
        line1 = ctMatch2 ? ctMatch2[1] : '';
        line2 = mmMatch2 ? mmMatch2[1] : '';
      }

      el.innerHTML =
        (line1 ? '<span class="gem-caption-name">' + line1 + '</span>' : '') +
        (line2 ? '<span class="gem-caption-sub">'  + line2 + '</span>' : '');

      el.style.whiteSpace = 'normal';
      el.style.textAlign  = 'center';
      el.style.display    = 'block';
      el.setAttribute('data-caption-formatted', '1');
    });
  }

  /* -------------------------------------------------------
     機能4: APOサムネイルバナー
  ------------------------------------------------------- */

  function formatSwatchBanners() {
    document.querySelectorAll('div.mw-option__swatch-media').forEach(function (media) {
      if (media.querySelector('.gem-swatch-banner')) return;

      var container = media.closest('.mw-stack');
      if (!container) return;
      var titleEl = container.querySelector('span.mw-option__value-text');
      if (!titleEl) return;

      var original = titleEl.getAttribute('data-original-text') || titleEl.textContent;
      if (original.indexOf('1点もの') === -1) return;

      var numMatch = original.match(/#(\d{3})/);
      var number   = numMatch ? '#' + numMatch[1] : '';

      var banner = document.createElement('div');
      banner.className = 'gem-swatch-banner';
      banner.innerHTML =
        '<span class="gem-swatch-banner__number">' + number + '</span>' +
        '<span class="gem-swatch-banner__label">1点もの</span>';

      media.style.position = 'relative';
      media.style.overflow = 'hidden';
      media.appendChild(banner);
    });
  }

  /* -------------------------------------------------------
     機能5b: Value labelの | を改行に変換
  ------------------------------------------------------- */

  function formatPipeBreaks() {
    document.querySelectorAll('span.mw-text.mw-option__value-text').forEach(function (el) {
      var original = (el.getAttribute('data-original-text') || el.textContent).trim();
      if (original.indexOf('|') === -1) return;
      if (original.match(/[\d.]+[Cc][Tt]/) || original.match(/[\d.]+×[\d.]+mm/)) return;
      el.style.whiteSpace = 'normal';
      el.style.textAlign  = 'center';
      el.style.display    = 'block';
      var escaped = original.trim()
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/\s*\|\s*/g, '|||')
        .split('|||').map(function(s){ return '<span style="display:block;text-align:left">' + s.trim() + '</span>'; }).join('');
      el.innerHTML = escaped;
      el.setAttribute('data-pipe-formatted', '1');
    });
  }

  /* -------------------------------------------------------
     機能5: APO価格ラベルへのカンマ挿入・「+」「()」除去
  ------------------------------------------------------- */

  function formatPriceLabels() {
    // mw-option__price：毎回処理（APO再描画後の +¥XX 復活に対応）
    // +¥1,800 / (+¥1,800) / ¥1,800 いずれも ¥X,XXX に統一
    document.querySelectorAll('span.mw-option__price').forEach(function (el) {
      var text = el.textContent.trim();
      var match = text.match(/[+\-]?\s*¥\s*([\d,]+)/);
      if (match) {
        var amount = Number(match[1].replace(/,/g, '')).toLocaleString('ja-JP');
        el.textContent = '¥' + amount;
      }
      el.setAttribute('data-price-formatted', '1');
    });

    // span.mw-text の差分価格 (+¥19300) → ¥19,300（+と()を除去・カンマ整形）
    document.querySelectorAll('span.mw-text').forEach(function (el) {
      if (el.getAttribute('data-size-price-formatted')) return;
      var text = el.textContent;
      var match = text.match(/\(\s*[+\-]\s*¥\s*(\d+)\s*\)/);
      if (!match) return;
      var amount = Number(match[1]).toLocaleString('ja-JP');
      el.textContent = '¥' + amount;
      el.setAttribute('data-size-price-formatted', '1');
    });

    // セレクトボックスの差分価格 「1号 (+¥19300)」→「1号　　¥19,300」（全角スペース2つ・毎回処理）
    document.querySelectorAll('select.mw-option__control option').forEach(function (option) {
      option.text = option.text.replace(/\s*\([+\-]¥(\d+)\)\s*$/, function (match, num) {
        return '　　¥' + Number(num).toLocaleString('ja-JP');
      });
    });
  }

  /* -------------------------------------------------------
     機能6: 特価バッジの表示
  ------------------------------------------------------- */

  function formatTokkaBadges() {
    var styleId  = 'gem-tokka-style';
    var existing = document.getElementById(styleId);
    if (existing) existing.parentNode.removeChild(existing);

    var valueIds = [];

    document.querySelectorAll('span.mw-text.mw-option__value-text').forEach(function (el) {
      var original = el.getAttribute('data-original-text') || el.textContent;
      if (original.indexOf('特価') === -1) return;

      var near = el.closest('.mw-stack__near');
      if (near) {
        var priceItem = near.querySelector('.mw-stack__item-price');
        if (priceItem) {
          priceItem.style.cssText = 'display:block !important; text-align:center !important;';
        }
      }

      var valueEl = el.closest('[data-value-id]');
      if (!valueEl) return;
      var valueId = valueEl.getAttribute('data-value-id');
      if (valueId && valueIds.indexOf(valueId) === -1) {
        valueIds.push(valueId);
      }
    });

    if (valueIds.length === 0) return;

    var priceSelectors  = valueIds.map(function(id) { return '[data-value-id="' + id + '"] .mw-option__price'; });
    var beforeSelectors = valueIds.map(function(id) { return '[data-value-id="' + id + '"] .mw-option__price::before'; });

    var css =
      priceSelectors.join(',\n') + ' {\n' +
      '  display: inline-block !important;\n' +
      '  width: auto !important;\n' +
      '  text-align: left !important;\n' +
      '  vertical-align: middle;\n' +
      '}\n\n' +
      beforeSelectors.join(',\n') + ' {\n' +
      '  content: "特価";\n' +
      '  display: inline-block;\n' +
      '  margin-right: 5px;\n' +
      '  font-size: 9px;\n' +
      '  letter-spacing: 0.06em;\n' +
      '  color: #fff;\n' +
      '  background-color: #b5534a;\n' +
      '  border-radius: 3px;\n' +
      '  padding: 1px 4px;\n' +
      '  line-height: 1.4;\n' +
      '  white-space: nowrap;\n' +
      '  vertical-align: middle;\n' +
      '}\n';

    var styleEl = document.createElement('style');
    styleEl.id          = styleId;
    styleEl.textContent = css;
    document.head.appendChild(styleEl);
  }

  function runFormatters() {
    formatTokkaBadges();
    formatSwatchLabels();
    formatSwatchBanners();
    formatPriceLabels();
    formatPipeBreaks();
  }

  function observeApo() {
    var target = document.querySelector('.mw-apo-container') || document.body;
    var timer  = null;
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(runFormatters, 300);
    }).observe(target, { childList: true, subtree: true });
  }

  function init() {
    updateAll();
    bindThumbEvents();
    bindSwatchEvents();
    bindMetalColorEvents();

    setTimeout(formatTokkaBadges,    400);
    setTimeout(formatSwatchLabels,   500);
    setTimeout(formatSwatchBanners,  500);
    setTimeout(formatPriceLabels,    500);
    setTimeout(formatPipeBreaks,     500);
    setTimeout(formatTokkaBadges,   1400);
    setTimeout(formatSwatchLabels,  1500);
    setTimeout(formatSwatchBanners, 1500);
    setTimeout(formatPriceLabels,   1500);
    setTimeout(formatPipeBreaks,    1500);
    observeApo();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();